/* iPhumat — Reprise wizard v2
 *
 * Wizard 4 étapes : modèle → stockage → état → contact.
 * Calcul local (grille de référence) avec fallback Odoo si endpoint dispo.
 * Pas de dépendance externe ; AA-friendly (focus, aria-live).
 */
(function () {
  'use strict';

  // ─── Grille de référence iPhumat (base juin 2026, € TTC, état A) ──────
  // Source : moyenne marché reconditionné FR. Coefficients d'état appliqués.
  // À ajuster côté Odoo (l10n.fr.tva.marge.pricing.grid.line) pour overrides.
  const MODELS = [
    { id: 'iphone-17-pro-max',  label: 'iPhone 17 Pro Max',  base: { 256: 1180, 512: 1320, 1024: 1480 } },
    { id: 'iphone-17-pro',      label: 'iPhone 17 Pro',      base: { 256: 1000, 512: 1140, 1024: 1280 } },
    { id: 'iphone-17',          label: 'iPhone 17',          base: { 256:  790, 512:  920 } },
    { id: 'iphone-16-pro-max',  label: 'iPhone 16 Pro Max',  base: { 256: 1050, 512: 1180, 1024: 1320 } },
    { id: 'iphone-16-pro',      label: 'iPhone 16 Pro',      base: { 128:  880, 256:  980, 512: 1120 } },
    { id: 'iphone-16-plus',     label: 'iPhone 16 Plus',     base: { 128:  720, 256:  820, 512:  960 } },
    { id: 'iphone-16',          label: 'iPhone 16',          base: { 128:  640, 256:  720, 512:  860 } },
    { id: 'iphone-15-pro-max',  label: 'iPhone 15 Pro Max',  base: { 256:  860, 512:  980, 1024: 1100 } },
    { id: 'iphone-15-pro',      label: 'iPhone 15 Pro',      base: { 128:  720, 256:  820, 512:  960 } },
    { id: 'iphone-15-plus',     label: 'iPhone 15 Plus',     base: { 128:  580, 256:  680, 512:  820 } },
    { id: 'iphone-15',          label: 'iPhone 15',          base: { 128:  520, 256:  600, 512:  740 } },
    { id: 'iphone-14-pro-max',  label: 'iPhone 14 Pro Max',  base: { 128:  680, 256:  780, 512:  900 } },
    { id: 'iphone-14-pro',      label: 'iPhone 14 Pro',      base: { 128:  580, 256:  660, 512:  780 } },
    { id: 'iphone-14-plus',     label: 'iPhone 14 Plus',     base: { 128:  460, 256:  540, 512:  660 } },
    { id: 'iphone-14',          label: 'iPhone 14',          base: { 128:  400, 256:  480, 512:  600 } },
    { id: 'iphone-13-pro-max',  label: 'iPhone 13 Pro Max',  base: { 128:  540, 256:  620, 512:  740 } },
    { id: 'iphone-13-pro',      label: 'iPhone 13 Pro',      base: { 128:  460, 256:  540, 512:  640 } },
    { id: 'iphone-13',          label: 'iPhone 13',          base: { 128:  340, 256:  410, 512:  520 } },
    { id: 'iphone-13-mini',     label: 'iPhone 13 mini',     base: { 128:  300, 256:  360, 512:  460 } },
    { id: 'iphone-12-pro-max',  label: 'iPhone 12 Pro Max',  base: { 128:  420, 256:  490, 512:  590 } },
    { id: 'iphone-12-pro',      label: 'iPhone 12 Pro',      base: { 128:  340, 256:  400, 512:  490 } },
    { id: 'iphone-12',          label: 'iPhone 12',          base: { 64:   240, 128:  280, 256:  330 } },
    { id: 'iphone-12-mini',     label: 'iPhone 12 mini',     base: { 64:   200, 128:  240, 256:  290 } },
    { id: 'iphone-11-pro-max',  label: 'iPhone 11 Pro Max',  base: { 64:   280, 256:  340, 512:  410 } },
    { id: 'iphone-11-pro',      label: 'iPhone 11 Pro',      base: { 64:   230, 256:  290, 512:  350 } },
    { id: 'iphone-11',          label: 'iPhone 11',          base: { 64:   160, 128:  190, 256:  230 } },
    { id: 'iphone-se-2022',     label: 'iPhone SE (2022)',   base: { 64:   140, 128:  170, 256:  210 } },
    { id: 'iphone-xr',          label: 'iPhone XR',          base: { 64:   110, 128:  130, 256:  160 } },
    { id: 'iphone-xs-max',      label: 'iPhone XS Max',      base: { 64:   140, 256:  180, 512:  220 } },
    { id: 'iphone-xs',          label: 'iPhone XS',          base: { 64:   110, 256:  150, 512:  190 } },
    { id: 'iphone-other',       label: 'Autre / plus ancien', base: { 0:     60 } }
  ];

  // Coefficients d'état (multiplicateur sur le prix de base).
  // A = comme neuf · B = bon · C = correct · D = abîmé · E = HS pour pièces.
  const GRADE_COEF = { A: 1.00, B: 0.86, C: 0.70, D: 0.50, E: 0.22 };

  // Modificateurs liés aux questions (additifs sur le coef, plafonnés).
  const Q_MODS = {
    screen:    { intact: 0,   scratched: -0.05, cracked: -0.18 },
    back:      { intact: 0,   scratched: -0.04, cracked: -0.12 },
    func:      { ok: 0,       partial: -0.20,   ko: -0.45 },
    battery:   { high: 0.03,  mid: 0,           low: -0.06,  unknown: 0 }
  };

  function money(v) {
    try { return new Intl.NumberFormat('fr-FR', { style:'currency', currency:'EUR', maximumFractionDigits:0 }).format(v); }
    catch (_) { return Math.round(v) + ' €'; }
  }

  function computeGrade(answers) {
    // Détermine le grade à partir des réponses si l'utilisateur n'a pas choisi.
    if (answers.func === 'ko') return 'E';
    if (answers.func === 'partial') return 'D';
    if (answers.screen === 'cracked' || answers.back === 'cracked') return 'C';
    if (answers.screen === 'scratched' || answers.back === 'scratched') return 'B';
    return 'A';
  }

  function estimateLocal(answers) {
    const model = MODELS.find(m => m.id === answers.model);
    if (!model) return null;
    const storages = Object.keys(model.base).map(Number).sort((a,b)=>a-b);
    const storage = storages.includes(Number(answers.storage)) ? Number(answers.storage) : storages[0];
    const basePrice = model.base[storage];
    const grade = answers.gradeOverride || computeGrade(answers);
    let coef = GRADE_COEF[grade];
    // Modificateurs questions (capés pour rester cohérents).
    let delta = 0;
    if (answers.screen)  delta += Q_MODS.screen[answers.screen] || 0;
    if (answers.back)    delta += Q_MODS.back[answers.back] || 0;
    if (answers.func)    delta += Q_MODS.func[answers.func] || 0;
    if (answers.battery) delta += Q_MODS.battery[answers.battery] || 0;
    coef = Math.max(0.18, Math.min(1.05, coef + delta));
    const price = Math.max(20, Math.round(basePrice * coef / 5) * 5);
    const min = Math.max(15, Math.round(price * 0.85 / 5) * 5);
    const max = Math.round(price * 1.08 / 5) * 5;
    return { price, min, max, grade, model: model.label, storage };
  }

  function tryRemoteEstimate(endpoint, answers, cb) {
    if (!endpoint) return cb(null);
    const payload = {
      sector: answers.deviceType || 'phone',
      device_type: answers.deviceType || 'phone',
      brand: 'Apple',
      model_name: answers.modelName || (MODELS.find(m => m.id === answers.model) || {}).label || '',
      storage: String(answers.storage || ''),
      grade: answers.gradeOverride || computeGrade(answers)
    };
    fetch(endpoint, { method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify(payload) })
      .then(r => r.json())
      .then(res => cb(res && res.found && res.price > 0 ? res : null))
      .catch(() => cb(null));
  }

  // ─── DOM helpers ─────────────────────────────────────────────────────
  function $ (sel, root) { return (root || document).querySelector(sel); }
  function $$ (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function init(root) {
    const estimateEndpoint = root.getAttribute('data-estimate-endpoint') || '';
    const leadEndpoint = root.getAttribute('data-lead-endpoint') || '';
    const secret = root.getAttribute('data-secret') || '';
    const shopUrl = root.getAttribute('data-shop-url') || '/collections/all';
    // Bonus avoir : configurable depuis la section. 0 = pas d'option avoir.
    const bonusPct = Math.max(0, Math.min(50, parseFloat(root.getAttribute('data-credit-bonus-pct')) || 0));
    const creditMonths = Math.max(1, parseInt(root.getAttribute('data-credit-validity-months'), 10) || 6);

    const stepsEl  = $('[data-steps]', root);
    const progress = $('[data-progress]', root);
    const statusEl = $('[data-status]', root);

    const answers = { deviceType:'phone', model:'', modelName:'', storage:'', screen:'', back:'', func:'', battery:'', gradeOverride:'' };
    const modelsEndpoint = root.getAttribute('data-models-endpoint') || '';
    // Modèles iPad/Mac chargés en direct depuis Odoo (noms bruts, 2020+).
    // { tablet:[{name,storages:[]}], computer:[...] }. iPhone garde sa grille locale.
    const REMOTE_MODELS = { tablet: [], computer: [] };
    if (modelsEndpoint) {
      fetch(modelsEndpoint, { headers:{Accept:'application/json'} })
        .then(r => r.json()).then(d => {
          if (d && d.ok && d.models) {
            REMOTE_MODELS.tablet = d.models.tablet || [];
            REMOTE_MODELS.computer = d.models.computer || [];
          }
        }).catch(function(){});
    }
    // Nom de modèle envoyé à Odoo (matching prix). iPhone : label de la grille ;
    // iPad/Mac : nom brut Odoo déjà stocké dans answers.modelName.
    function modelName() {
      if (answers.deviceType === 'phone') {
        return (MODELS.find(m => m.id === answers.model) || {}).label || '';
      }
      return answers.modelName || '';
    }
    // Mode de paiement par défaut : avoir si un bonus est configuré (incite à
    // garder la valeur dans la boutique), sinon cash.
    let payoutMethod = bonusPct > 0 ? 'credit' : 'cash';
    // Sous-méthode quand le client choisit « cash » : 'sepa' (virement) ou 'paypal'.
    // RIB / email PayPal seront demandés post-soumission via un lien sécurisé.
    let cashChannel = 'sepa';
    // Mode de dépôt : 'shop' (atelier Bondoufle) ou 'remote' (envoi colis pré-affranchi).
    let pickupMode = 'shop';
    let lastEstimate = null;
    let stepIdx = 0;

    // ─ Build step 1 : modèles ────────────────────────────────────────
    const step1 = buildStep('Quel appareil ?', 'iPhone, iPad ou Mac — puis choisissez le modèle.', renderModels());
    // ─ Build step 2 : stockage (rebuild dynamique) ───────────────────
    const step2 = buildStep('Quel stockage ?', 'Visible dans Réglages › Général › Informations.', '<div data-storage-grid></div>');
    // ─ Build step 3 : état ───────────────────────────────────────────
    const step3 = buildStep('Dans quel état ?', 'Trois questions rapides — soyez honnête, ça nous évite des allers-retours.',
      renderStateQuestions());
    // ─ Build step 4 : résultat ───────────────────────────────────────
    const step4 = buildResult();

    stepsEl.appendChild(step1);
    stepsEl.appendChild(step2);
    stepsEl.appendChild(step3);
    stepsEl.appendChild(step4);

    // Délégation clic sur les chips
    stepsEl.addEventListener('click', function (e) {
      const chip = e.target.closest('[data-pick]');
      if (!chip) return;
      const field = chip.getAttribute('data-field');
      const value = chip.getAttribute('data-value');
      // Changement de type d'appareil : reset modèle, re-render la zone modèles.
      if (field === 'deviceType') {
        answers.deviceType = value;
        answers.model = ''; answers.modelName = ''; answers.storage = '';
        $$('[data-field="deviceType"]', stepsEl).forEach(b => b.classList.toggle('is-active', b === chip));
        const area = $('[data-model-area]', step1);
        if (area) area.innerHTML = renderModelArea(value);
        return;
      }
      answers[field] = value;
      // Marquer sélection visuelle
      $$('[data-field="'+field+'"]', stepsEl).forEach(b => b.classList.toggle('is-active', b === chip));
      // Sur modèle → re-construire grille stockages puis avancer
      if (field === 'model') {
        answers.modelName = (MODELS.find(m => m.id === value) || {}).label || '';
        rebuildStorages();
        goTo(1);
      } else if (field === 'storage') {
        goTo(2);
      } else {
        // Les 4 questions état doivent être renseignées avant d'avancer.
        if (answers.screen && answers.back && answers.func && answers.battery) {
          compute();
          goTo(3);
        }
      }
    });

    // Navigation : retour
    stepsEl.addEventListener('click', function (e) {
      if (e.target.matches('[data-back]')) { goTo(Math.max(0, stepIdx - 1)); }
      if (e.target.matches('[data-restart]')) { restart(); }
    });

    // Sélection d'un modèle iPad/Mac via le menu déroulant.
    stepsEl.addEventListener('change', function (e) {
      const sel = e.target.closest('[data-model-select]');
      if (!sel) return;
      answers.modelName = sel.value || '';
      answers.model = sel.value || '';   // pour iPad/Mac, id = nom brut
      if (!answers.modelName) return;
      rebuildStorages();
      goTo(1);
    });

    // Recherche par numéro A (au dos de l'appareil) pour iPad/Mac.
    stepsEl.addEventListener('click', function (e) {
      if (!e.target.matches('[data-a-search]')) return;
      const input = $('[data-a-code]', step1);
      resolveACode(input && input.value);
    });
    stepsEl.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter') return;
      const input = e.target.closest('[data-a-code]');
      if (!input) return;
      e.preventDefault();
      resolveACode(input.value);
    });

    function storagesForCurrent() {
      if (answers.deviceType === 'phone') {
        const model = MODELS.find(m => m.id === answers.model);
        return model ? Object.keys(model.base).map(Number).sort((a,b)=>a-b) : [];
      }
      const list = REMOTE_MODELS[answers.deviceType] || [];
      const m = list.find(x => x.name === answers.modelName);
      return m ? (m.storages || []).map(Number).sort((a,b)=>a-b) : [];
    }
    function rebuildStorages() {
      const grid = $('[data-storage-grid]', step2);
      const storages = storagesForCurrent();
      if (!storages.length) { grid.innerHTML = '<p class="rep-step__sub">Stockage non précisé — continuez.</p>'; return; }
      grid.innerHTML = '<div class="rep-chips">' +
        storages.map(s => '<button type="button" class="rep-chip" data-pick data-field="storage" data-value="'+s+'">'+
          (s === 0 ? '—' : (s >= 1000 ? (s/1000 >= 2 ? (s/1000)+' To' : '1 To') : (s + ' Go'))) +
        '</button>').join('') + '</div>';
    }

    function compute() {
      const local = estimateLocal(answers);   // null pour iPad/Mac (pas de grille locale)
      renderEstimate(local, /*remote*/ false);
      const grade = (local && local.grade) || answers.gradeOverride || computeGrade(answers);
      const label = (local && local.model) || modelName();
      const sto = (local && local.storage) || answers.storage;
      tryRemoteEstimate(estimateEndpoint, answers, function (remote) {
        if (remote) {
          renderEstimate({
            price: remote.price,
            min: remote.min_price || Math.round(remote.price * 0.85),
            max: remote.max_price || Math.round(remote.price * 1.08),
            grade: grade, model: label, storage: sto
          }, true);
        }
      });
    }

    function renderEstimate(est, fromRemote) {
      const priceEl = $('[data-price]', step4);
      const subEl   = $('[data-sub]', step4);
      const compareEl = $('[data-compare]', step4);
      const recapEl = $('[data-recap]', step4);
      lastEstimate = est;
      // Active/désactive le bouton submit selon qu'on a une estimation valide.
      // Sans modèle ou avec estimation indispo, on ne devrait pas pouvoir
      // submitter (sinon lead inexploitable côté atelier).
      const submitBtn = $('[data-rep-submit]', step4);
      if (submitBtn) {
        const ok = !!(est && est.price > 0);
        submitBtn.disabled = !ok;
        submitBtn.style.opacity = ok ? '' : '.5';
        submitBtn.style.cursor = ok ? '' : 'not-allowed';
        submitBtn.title = ok ? '' : 'Sélectionnez un modèle pour activer';
      }
      if (!est) {
        priceEl.textContent = 'Estimation sur mesure';
        subEl.textContent = 'Sélectionnez un modèle pour obtenir une estimation chiffrée.';
        if (compareEl) compareEl.textContent = '';
        renderPayoutChoice(null);
        return;
      }
      // Le « Jusqu'à » doit refléter le MEILLEUR montant que le client peut
      // obtenir — soit l'avoir boosté (+bonus%) si configuré, soit le cash.
      // Sinon le titre semble contredire l'option « recommandée » en dessous.
      const bestAmount = Math.max(est.price, creditAmount(est.price) || 0);
      priceEl.textContent = 'Jusqu’à ' + money(bestAmount);
      // La fourchette reste basée sur le prix cash (référence diagnostic).
      subEl.textContent = 'Fourchette : ' + money(est.min) + ' – ' + money(est.max);
      recapEl.innerHTML = est.model + ' · ' + (est.storage ? (est.storage >= 1024 ? '1 To' : est.storage + ' Go · ') : '') + 'grade ' + est.grade;
      if (compareEl) compareEl.textContent = 'Estimation indicative — montant final confirmé après diagnostic en atelier.';
      renderPayoutChoice(est);
      renderPickupChoice(est);
      renderRepairCrossSell(est);
    }

    // Choix mode de dépôt : boutique (Bondoufle) vs envoi à distance (colis pré-affranchi).
    // Selon le choix, le formulaire de contact affiche/masque les champs d'adresse.
    function renderPickupChoice(est) {
      const host = $('[data-pickup]', step4);
      if (!host || !est) return;
      host.hidden = false;
      const shopAddr = root.getAttribute('data-shop-address') || '29 rue Charles de Gaulle, 91070 Bondoufle';
      host.innerHTML =
        '<h4 class="rep-payout__title">Comment souhaitez-vous procéder&nbsp;?</h4>' +
        '<div class="rep-payout__cards">' +
          '<button type="button" class="rep-payout__card' + (pickupMode === 'shop' ? ' is-selected' : '') + '" data-pickup-pick="shop">' +
            '<span class="rep-payout__lbl">📍 Dépôt en boutique</span>' +
            '<span class="rep-payout__price" style="font-size:18px">Atelier Bondoufle</span>' +
            '<span class="rep-payout__note">' + shopAddr + '. Diagnostic devant vous, paiement immédiat. Apportez une <b>pièce d\'identité</b> (obligatoire).</span>' +
          '</button>' +
          '<button type="button" class="rep-payout__card' + (pickupMode === 'remote' ? ' is-selected' : '') + '" data-pickup-pick="remote">' +
            '<span class="rep-payout__lbl">✉ Envoi sécurisé — 100 % à notre charge</span>' +
            '<span class="rep-payout__price" style="font-size:18px">Étiquette prépayée</span>' +
            '<span class="rep-payout__note"><b>Vous ne payez rien.</b> On vous envoie l\'étiquette prépayée par email&#160;: déposez le colis en point relais. <b>Offre garantie 7 jours</b> — au-delà, le bon expire et le prix est réévalué (la téléphonie évolue comme une cote). Données effacées et certifiées à réception.</span>' +
          '</button>' +
        '</div>';
      $$('[data-pickup-pick]', host).forEach(b => b.addEventListener('click', function () {
        pickupMode = b.getAttribute('data-pickup-pick');
        $$('[data-pickup-pick]', host).forEach(x => x.classList.toggle('is-selected', x === b));
        toggleShippingFields();
      }));
      toggleShippingFields();
    }

    function toggleShippingFields() {
      const subEl2 = $('[data-lead-sub]', step4);
      if (subEl2) {
        subEl2.innerHTML = pickupMode === 'remote'
          ? 'On vous envoie une <b>étiquette prépayée</b> par email&#160;: déposez le colis en point relais sous <b>7 jours</b>. Données effacées à réception.'
          : 'Apportez votre appareil à l’<b>atelier de Bondoufle</b> aux horaires d’ouverture. Paiement immédiat après diagnostic.';
      }
      const shipBlock = $('[data-shipping-block]', step4);
      if (!shipBlock) return;
      shipBlock.hidden = pickupMode !== 'remote';
      // Required toggled on visibility
      $$('[data-shipping-required]', shipBlock).forEach(inp => {
        inp.required = pickupMode === 'remote';
      });
    }

    // Choix mode de paiement : cash (SEPA/PayPal) vs avoir iPhumat (+bonus%).
    // L'avoir est mis en avant comme « recommandé » s'il est configuré (>0%).
    function creditAmount(price) {
      if (!price || bonusPct <= 0) return price;
      return Math.round(price * (1 + bonusPct / 100) / 5) * 5;
    }
    function renderPayoutChoice(est) {
      const host = $('[data-payout]', step4);
      if (!host) return;
      if (!est || bonusPct <= 0) { host.innerHTML = ''; host.hidden = true; return; }
      host.hidden = false;
      const cashAmt = est.price;
      const credAmt = creditAmount(est.price);
      const credSel = payoutMethod === 'credit';
      const cashSel = payoutMethod === 'cash';
      host.innerHTML =
        '<h4 class="rep-payout__title">Comment souhaitez-vous être payé&nbsp;?</h4>' +
        '<div class="rep-payout__cards">' +
          '<button type="button" class="rep-payout__card rep-payout__card--credit' + (credSel ? ' is-selected' : '') + '" data-payout-pick="credit">' +
            '<span class="rep-payout__tag">Recommandé</span>' +
            '<span class="rep-payout__lbl">Avoir iPhumat <small>+' + bonusPct + ' %</small></span>' +
            '<span class="rep-payout__price">' + money(credAmt) + '</span>' +
            '<span class="rep-payout__note">Crédit boutique — valable ' + creditMonths + ' mois sur un iPhone reconditionné iPhumat.</span>' +
          '</button>' +
          '<button type="button" class="rep-payout__card' + (cashSel ? ' is-selected' : '') + '" data-payout-pick="cash">' +
            '<span class="rep-payout__lbl">Reprise cash</span>' +
            '<span class="rep-payout__price">' + money(cashAmt) + '</span>' +
            '<span class="rep-payout__note">Virement SEPA ou PayPal sous 3 j ouvrés après diagnostic.</span>' +
          '</button>' +
        '</div>' +
        // Sous-choix SEPA / PayPal — affiché uniquement si "cash" est sélectionné.
        '<div data-cash-channel hidden style="margin-top:14px;padding:14px 16px;background:#faf6ee;border-radius:12px">' +
          '<p style="margin:0 0 10px;font-size:14px;font-weight:700;color:#2a2118">Mode de paiement cash</p>' +
          '<div style="display:flex;gap:10px;flex-wrap:wrap">' +
            '<label style="display:flex;align-items:center;gap:8px;padding:8px 14px;border:1px solid var(--line,#e6ddd0);border-radius:999px;background:#fff;cursor:pointer">' +
              '<input type="radio" name="cash_channel" value="sepa"' + (cashChannel === 'sepa' ? ' checked' : '') + '> Virement SEPA' +
            '</label>' +
            '<label style="display:flex;align-items:center;gap:8px;padding:8px 14px;border:1px solid var(--line,#e6ddd0);border-radius:999px;background:#fff;cursor:pointer">' +
              '<input type="radio" name="cash_channel" value="paypal"' + (cashChannel === 'paypal' ? ' checked' : '') + '> PayPal' +
            '</label>' +
          '</div>' +
          '<p data-cash-channel-note style="margin:10px 0 0;font-size:12.5px;color:#7a6c58;line-height:1.5"></p>' +
        '</div>';
      $$('[data-payout-pick]', host).forEach(b => b.addEventListener('click', function () {
        payoutMethod = b.getAttribute('data-payout-pick');
        $$('[data-payout-pick]', host).forEach(x => x.classList.toggle('is-selected', x === b));
        updateCashChannelVisibility();
      }));
      $$('input[name="cash_channel"]', host).forEach(r => r.addEventListener('change', function () {
        cashChannel = r.value;
        updateCashChannelNote();
      }));
      updateCashChannelVisibility();
      function updateCashChannelVisibility() {
        const box = $('[data-cash-channel]', host);
        if (!box) return;
        box.hidden = payoutMethod !== 'cash';
        updateCashChannelNote();
      }
      function updateCashChannelNote() {
        const note = $('[data-cash-channel-note]', host);
        if (!note) return;
        note.innerHTML = cashChannel === 'paypal'
          ? '<b>PayPal</b> : on vous demandera votre adresse email PayPal après la demande, par lien sécurisé (avec pièce d\'identité recto-verso).'
          : '<b>SEPA</b> : on vous demandera votre RIB après la demande, par lien sécurisé (avec pièce d\'identité recto-verso).';
      }
    }

    // Cross-sell : si l'utilisateur a déclaré une panne réparable, proposer
    // un rebond vers le wizard réparation (avec contexte modèle pré-sélectionné).
    function renderRepairCrossSell(est) {
      const wrap = $('[data-repair-crosssell]', step4);
      if (!wrap) return;
      const labels = [];
      if (answers.screen === 'cracked')   labels.push({ k: 'screen',  l: 'écran fissuré' });
      if (answers.back === 'cracked')     labels.push({ k: 'back',    l: 'face arrière cassée' });
      if (answers.battery === 'low')      labels.push({ k: 'battery', l: 'batterie usée' });
      if (answers.func === 'partial')     labels.push({ k: 'other',   l: 'défaut fonctionnel' });
      if (!labels.length) { wrap.hidden = true; wrap.innerHTML = ''; return; }
      wrap.hidden = false;
      const issuesQs = labels.map(l => l.k).join(',');
      const issuesLbl = labels.map(l => l.l).join(' + ');
      const url = (root.getAttribute('data-repair-url') || '/pages/reparation') +
                  '?model=' + encodeURIComponent(answers.model) + '&issues=' + encodeURIComponent(issuesQs);
      wrap.innerHTML =
        '<p class="rep-cross__eyebrow">Plutôt que revendre, on peut réparer.</p>' +
        '<h4 class="rep-cross__title">Vous avez déclaré ' + issuesLbl + ' — on peut intervenir, vous gardez votre ' + est.model + '.</h4>' +
        '<a class="btn btn--ghost" href="' + url + '">Voir le tarif de réparation →</a>';
    }

    // ─ Lead form ────────────────────────────────────────────────────
    const leadForm = $('[data-lead-form]', step4);
    if (leadForm) {
      leadForm.addEventListener('submit', function (e) {
        e.preventDefault();
        const el = leadForm.elements;
        const firstName = el['first_name'].value.trim();
        const lastName  = el['last_name'].value.trim();
        const phone     = el['phone'].value.trim();
        const email     = el['email'].value.trim();
        const amountCash = lastEstimate ? lastEstimate.price : null;
        const amountCredit = creditAmount(amountCash);
        const data = {
          name: (firstName + ' ' + lastName).trim(),
          first_name: firstName,
          last_name: lastName,
          phone: phone,
          email: email,
          device_model: (modelName() + (answers.storage ? ' ' + answers.storage + ' Go' : '')).trim(),
          device_type: answers.deviceType || 'phone',
          estimate: $('[data-price]', step4).textContent,
          // Critères déclarés par le client lors de l'estimation —
          // CRUCIAL côté commercial pour vérifier l'état à la réception.
          declared_storage: answers.storage || '',
          declared_grade: (lastEstimate && lastEstimate.grade) || answers.gradeOverride || computeGrade(answers),
          declared_screen: answers.screen || '',
          declared_back: answers.back || '',
          declared_func: answers.func || '',
          declared_battery: answers.battery || '',
          declared_a_code: answers.aCode || '',     // numéro modèle au dos (si saisi)
          payout_method: payoutMethod,
          cash_channel: cashChannel,                // 'sepa' | 'paypal' (si cash)
          amount_cash: amountCash,
          amount_credit: amountCredit,
          bonus_pct: bonusPct,
          credit_validity_months: creditMonths,
          pickup_mode: pickupMode,                // 'shop' | 'remote'
          website: el['website'].value
        };
        if (pickupMode === 'remote') {
          data.shipping_street = (el['street'] && el['street'].value || '').trim();
          data.shipping_postal_code = (el['postal_code'] && el['postal_code'].value || '').trim();
          data.shipping_city = (el['city'] && el['city'].value || '').trim();
          data.shipping_country = (el['country'] && el['country'].value || '').trim() || 'France';
          if (!data.shipping_street || !data.shipping_postal_code || !data.shipping_city) {
            setStatus('Pour l’envoi à distance, l’adresse complète est requise.', 'error');
            return;
          }
        }
        if (!firstName || !lastName) { setStatus('Indiquez vos prénom et nom.', 'error'); return; }
        if (!phone) { setStatus('Indiquez un numéro de téléphone pour qu’on revienne vers vous.', 'error'); return; }
        // Validation téléphone : 10 chiffres FR (0X XX XX XX XX).
        const phoneDigits = phone.replace(/\D/g, '');
        if (!/^0\d{9}$/.test(phoneDigits)) {
          setStatus('Le téléphone doit faire 10 chiffres (ex. 06 12 34 56 78).', 'error');
          if (el['phone']) el['phone'].focus();
          return;
        }
        data.phone = phoneDigits;
        if (!email) { setStatus('Indiquez un email pour recevoir la proposition.', 'error'); return; }
        if (!leadEndpoint) { setStatus('Service indisponible.', 'error'); return; }
        setStatus('Envoi en cours…', '');
        // Token passé dans le body (et non en header custom) pour éviter
        // un preflight CORS bloquant (Odoo ne whitelist pas le header
        // X-iPhumat-Booking-Token). Le contrôleur accepte data.token.
        if (secret) data.token = secret;
        fetch(leadEndpoint, { method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify(data) })
          .then(r => r.json().catch(() => ({})).then(j => ({ ok:r.ok, body:j })))
          .then(res => {
            if (res.ok && res.body && res.body.ok) {
              // Remplace tout le bloc résultat par un message de confirmation
              // explicite — sinon le formulaire se vide et le client se demande
              // si sa demande est partie.
              const refTxt = (res.body.reference ? ' (réf. ' + esc(res.body.reference) + ')' : '');
              step4.innerHTML =
                '<div class="rep-result__price-card" style="text-align:center;padding:32px 24px">' +
                  '<p style="font-size:42px;margin:0 0 10px">✅</p>' +
                  '<p class="rep-result__label">Demande confirmée' + refTxt + '</p>' +
                  '<h3 style="margin:10px 0 6px;color:#2a2118">' +
                    (pickupMode === 'remote'
                      ? 'C\'est confirmé&#160;! On attend votre colis dans nos locaux.'
                      : 'C\'est confirmé&#160;! On vous attend à l\'atelier.') +
                  '</h3>' +
                  '<p style="color:#5b5043;line-height:1.6;max-width:520px;margin:8px auto 0">' +
                    (pickupMode === 'remote'
                      ? '📦 Votre <b>étiquette prépayée</b> arrive par email dans les prochaines minutes — déposez le colis en point relais sous <b>7 jours</b> pour garantir le prix. Vous recevrez aussi un lien sécurisé pour téléverser vos justificatifs (pièce d\'identité + RIB/PayPal), indispensables au paiement. On vous tient au courant à chaque étape&#160;: réception, diagnostic, virement.'
                      : '📍 Venez quand vous voulez à l\'<b>atelier de Bondoufle</b> (29 r. Ch. de Gaulle, 91070) — ouvert <b>Lun–Sam 10 h – 19 h</b>. Diagnostic en 15 min, paiement immédiat (CB, espèces ou avoir +10 %). Pensez à apporter une <b>pièce d\'identité</b> et votre <b>RIB</b> si paiement virement.') +
                  '</p>' +
                  '<p style="margin:20px 0 0;display:flex;gap:10px;flex-wrap:wrap;justify-content:center">' +
                    (pickupMode === 'shop'
                      ? '<a href="https://www.google.com/maps/search/?api=1&query=iPhumat+29+rue+Charles+de+Gaulle+91070+Bondoufle" target="_blank" rel="noopener" class="btn btn--ghost btn--lg">📍 Itinéraire Maps</a>' +
                        '<a href="tel:0176433524" class="btn btn--ghost btn--lg">📞 Appeler l\'atelier</a>'
                      : '') +
                  '</p>' +
                  '<p style="margin-top:24px"><a href="' + shopUrl + '" class="btn btn--accent btn--lg">Voir nos iPhone reconditionnés →</a></p>' +
                '</div>';
              // Remonte en haut du wizard pour que le client voie la
              // confirmation (sinon il reste collé sur le footer).
              try {
                const card = root.querySelector('.rep-card') || step4 || root;
                const top = card.getBoundingClientRect().top + window.pageYOffset - 24;
                window.scrollTo({ top: Math.max(0, top), behavior: 'auto' });
              } catch (_) {}
            } else { setStatus('Une erreur est survenue. Réessayez.', 'error'); }
          })
          .catch(() => setStatus('Connexion impossible. Réessayez.', 'error'));
      });
    }

    function setStatus(msg, kind) {
      if (!statusEl) return;
      statusEl.textContent = msg;
      statusEl.className = 'booking__status' + (kind ? ' is-' + kind : '');
    }

    function goTo(i) {
      stepIdx = i;
      $$('.rep-step', stepsEl).forEach((s, idx) => { s.hidden = idx !== i; });
      if (progress) progress.style.width = ((i + 1) / 4 * 100) + '%';
      // PAS de focus() ici : sur iOS Safari le focus auto fait scroller la
      // page jusqu'en bas (le clavier virtuel se hisse + viewport saute).
      // L'utilisateur a déjà le wizard sous les yeux ; on n'a pas besoin de
      // déplacer son scroll quand il passe d'une étape à l'autre.
    }
    function restart() {
      Object.keys(answers).forEach(k => answers[k] = '');
      answers.deviceType = 'phone';
      $$('.is-active', stepsEl).forEach(b => b.classList.remove('is-active'));
      const area = $('[data-model-area]', step1);
      if (area) area.innerHTML = renderModelArea('phone');
      $$('[data-field="deviceType"]', step1).forEach(b => b.classList.toggle('is-active', b.getAttribute('data-value') === 'phone'));
      goTo(0);
    }
    goTo(0);

    // Préremplissage depuis fiche produit : /pages/reprise?model=iPhone%2013&grade=B
    // (le widget reprise inline sur la page produit pousse vers ici en query).
    // On retrouve l'id MODELS par son label exact, on déclenche le clic chip,
    // et on capture le grade dans answers.gradeOverride (utilisé dans compute()).
    try {
      const qp = new URLSearchParams(window.location.search);
      const qModel = (qp.get('model') || '').trim();
      const qGrade = (qp.get('grade') || '').trim().toUpperCase();
      if (qModel) {
        const m = MODELS.find(x => x.label.toLowerCase() === qModel.toLowerCase());
        if (m) {
          const chip = step1.querySelector('[data-field="model"][data-value="' + m.id + '"]');
          if (chip) chip.click();
        }
      }
      if (qGrade && 'ABC'.indexOf(qGrade) >= 0) {
        answers.gradeOverride = qGrade;
      }
    } catch (_) {}

    // ─── Builders ────────────────────────────────────────────────────
    function buildStep(title, subtitle, innerHtml) {
      const wrap = document.createElement('div');
      wrap.className = 'rep-step'; wrap.hidden = true;
      wrap.innerHTML =
        '<div class="rep-step__head">' +
          '<h3 class="rep-step__title">' + title + '</h3>' +
          '<p class="rep-step__sub">' + subtitle + '</p>' +
        '</div>' + innerHtml +
        '<div class="rep-step__nav"><button type="button" class="link-back" data-back>← Retour</button></div>';
      return wrap;
    }
    function renderModels() {
      // Onglets type d'appareil + zone modèles (remplie par renderModelArea).
      const tabs = [
        { v:'phone',    l:'iPhone' },
        { v:'tablet',   l:'iPad' },
        { v:'computer', l:'Mac' }
      ].map(t =>
        '<button type="button" class="rep-chip rep-chip--sm' + (t.v === answers.deviceType ? ' is-active' : '') +
        '" data-pick data-field="deviceType" data-value="' + t.v + '">' + t.l + '</button>'
      ).join('');
      return '<div class="rep-chips" style="margin-bottom:14px">' + tabs + '</div>' +
             '<div data-model-area>' + renderModelArea('phone') + '</div>';
    }
    function renderModelArea(type) {
      if (type === 'phone') {
        const items = MODELS.map(m =>
          '<button type="button" class="rep-chip" data-pick data-field="model" data-value="' + m.id + '">' + m.label + '</button>'
        ).join('');
        return '<div class="rep-chips rep-chips--wrap">' + items + '</div>';
      }
      // iPad / Mac : champ « code A » (numéro Apple au dos) + dropdown de secours.
      // Le client lit le code « A + 4 chiffres » au dos de son appareil et le tape.
      // Endpoint Odoo /reprise/resolve trouve le bon modèle et pré-remplit le wizard.
      const list = REMOTE_MODELS[type] || [];
      const dropdownPlaceholder = list.length ? 'Ou choisissez dans la liste…' : 'Chargement des modèles…';
      const opts = ['<option value="">— ' + dropdownPlaceholder + ' —</option>']
        .concat(list.map(m => '<option value="' + esc(m.name) + '">' + esc(m.name) + '</option>')).join('');
      return '<div class="rep-a-search" style="margin-bottom:14px">' +
        '<label style="display:block;font-size:13px;color:#7a6c58;margin-bottom:6px">' +
          'Code modèle au dos de l\'appareil (ex. <b>A2442</b>)' +
        '</label>' +
        '<div style="display:flex;gap:8px;align-items:stretch">' +
          '<input type="text" data-a-code placeholder="A____" autocomplete="off" inputmode="text" ' +
            'style="flex:1;padding:12px;border:1px solid var(--line,#e6ddd0);border-radius:10px;font:inherit;font-size:15px;text-transform:uppercase">' +
          '<button type="button" data-a-search class="btn btn--ghost" ' +
            'style="padding:0 18px;border:1px solid var(--accent,#9a5b34);background:#fff;color:var(--accent,#9a5b34);border-radius:10px;font:inherit;cursor:pointer">Chercher</button>' +
        '</div>' +
        '<p data-a-status style="margin:8px 0 0;font-size:13px;color:#7a6c58;min-height:18px"></p>' +
      '</div>' +
      '<select data-model-select class="rep-select" style="width:100%;padding:12px;border-radius:10px;font-size:15px;border:1px solid var(--line,#e6ddd0)">' + opts + '</select>';
    }

    // Résolution du code A (au dos de l'appareil) côté Odoo.
    function resolveACode(code) {
      const status = $('[data-a-status]', step1);
      if (!status) return;
      const clean = (code || '').trim().toUpperCase();
      if (!/^A\d{3,4}$/.test(clean)) {
        status.textContent = 'Format attendu : A suivi de 4 chiffres (ex. A2442).';
        status.style.color = '#9a5b34';
        return;
      }
      // Mémorise le code A déclaré (transmis au backend dans le payload lead).
      answers.aCode = clean;
      const base = (root.getAttribute('data-models-endpoint') || '')
        .replace('/reprise/models', '/reprise/resolve');
      if (!base) { status.textContent = ''; return; }
      status.textContent = 'Recherche…';
      status.style.color = '#7a6c58';
      fetch(base + '?code=' + encodeURIComponent(clean), { headers:{Accept:'application/json'} })
        .then(r => r.json())
        .then(d => {
          const models = (d && d.models) || [];
          if (!models.length) {
            status.textContent = 'Code introuvable — utilisez la liste ci-dessous.';
            status.style.color = '#c45a3f';
            return;
          }
          // 1 seul match : on pré-sélectionne et on avance.
          if (models.length === 1) {
            answers.modelName = models[0].name;
            answers.model = models[0].name;
            rebuildStorages();
            status.textContent = '✓ ' + models[0].name;
            status.style.color = '#2a7a4a';
            goTo(1);
            return;
          }
          // Plusieurs matches : on filtre le dropdown sur ces modèles uniquement.
          const sel = $('[data-model-select]', step1);
          if (sel) {
            sel.innerHTML = '<option value="">— ' + models.length + ' modèles correspondent, choisissez —</option>' +
              models.map(m => '<option value="' + esc(m.name) + '">' + esc(m.name) + '</option>').join('');
            sel.focus();
          }
          status.textContent = models.length + ' modèles correspondent à ' + clean + '.';
          status.style.color = '#2a7a4a';
        })
        .catch(() => { status.textContent = 'Erreur de connexion. Réessayez.'; status.style.color = '#c45a3f'; });
    }
    function esc(s){ var d=document.createElement('div'); d.textContent = s==null?'':String(s); return d.innerHTML; }
    function renderStateQuestions() {
      function q(field, label, opts) {
        return '<fieldset class="rep-q"><legend>' + label + '</legend><div class="rep-chips">' +
          opts.map(o => '<button type="button" class="rep-chip rep-chip--sm" data-pick data-field="' + field + '" data-value="' + o.v + '">' + o.l + '</button>').join('') +
          '</div></fieldset>';
      }
      return q('screen', 'L’écran ?',     [{v:'intact',l:'Intact'}, {v:'scratched',l:'Micro-rayures'}, {v:'cracked',l:'Fissuré'}]) +
             q('back',   'La face arrière ?', [{v:'intact',l:'Intacte'}, {v:'scratched',l:'Rayures'}, {v:'cracked',l:'Cassée'}]) +
             q('func',   'Tout fonctionne ?', [{v:'ok',l:'Oui, tout'}, {v:'partial',l:'Un défaut'}, {v:'ko',l:'Plusieurs défauts'}]) +
             q('battery','Santé batterie ? (Réglages › Batterie › État)', [{v:'high',l:'≥ 90 %'},{v:'mid',l:'80–90 %'},{v:'low',l:'< 80 %'},{v:'unknown',l:'Je ne sais pas'}]);
    }
    function buildResult() {
      const w = document.createElement('div');
      w.className = 'rep-step rep-result'; w.hidden = true;
      w.innerHTML =
        '<div class="rep-result__price-card">' +
          '<p class="rep-result__label">Votre reprise</p>' +
          '<p class="rep-result__price" data-price>—</p>' +
          '<p class="rep-result__sub" data-sub></p>' +
          // Mention transparence sous le prix : indicatif + confirmable atelier.
          '<p class="rep-result__honesty" style="margin:10px auto 0;max-width:480px;font-size:13px;color:#7a6c58;line-height:1.5">' +
            '<b>Estimation indicative</b> — confirmée à l\'atelier après diagnostic. ' +
            'Si l\'état réel de votre appareil correspond à ce que vous avez ' +
            'déclaré, <b>le prix ne change pas</b>. ⚡ Le stock varie ' +
            'beaucoup&#160;: passez vite à l\'action pour bloquer cette offre.' +
          '</p>' +
          '<p class="rep-result__recap" data-recap></p>' +
        '</div>' +
        // Bandeau « ce qui est inclus » — réassurance, transparence services.
        '<div class="rep-includes" style="margin:18px 0;padding:14px 18px;background:#f7f2e9;border-radius:12px;font-size:13px;color:#2a2118;line-height:1.6">' +
          '<p style="margin:0 0 6px;font-weight:700">Tout compris dans votre reprise iPhumat&#160;:</p>' +
          '<ul style="margin:0;padding-left:18px">' +
            '<li>📲 <b>Transfert de vos données</b> vers votre nouvel appareil (si racheté chez nous)</li>' +
            '<li>🧹 <b>Effacement certifié</b> de votre ancien iPhone (norme NIST, traçable)</li>' +
            '<li>📦 <b>Étiquette retour prépayée</b> (envoi distance) ou dépôt atelier — vous ne payez rien</li>' +
            '<li>💶 <b>Paiement sous 3 jours ouvrés</b> après réception et diagnostic</li>' +
          '</ul>' +
        '</div>' +
        '<p class="rep-result__compare" data-compare></p>' +
        '<div class="rep-payout" data-payout hidden></div>' +
        '<div class="rep-payout" data-pickup hidden></div>' +
        '<div class="rep-cross" data-repair-crosssell hidden></div>' +
        '<form class="reprise__lead" data-lead-form>' +
          '<p class="reprise__lead-title">Vos coordonnées pour finaliser la reprise</p>' +
          '<p class="reprise__lead-sub" data-lead-sub>Plus qu’une étape&#160;: vos coordonnées et c’est validé.</p>' +
          '<div class="field-row">' +
            '<div class="field"><label for="rwz-first">Prénom *</label><input id="rwz-first" name="first_name" type="text" autocomplete="given-name" required></div>' +
            '<div class="field"><label for="rwz-last">Nom *</label><input id="rwz-last" name="last_name" type="text" autocomplete="family-name" required></div>' +
          '</div>' +
          '<div class="field-row">' +
            '<div class="field"><label for="rwz-phone">Téléphone *</label><input id="rwz-phone" name="phone" type="tel" autocomplete="tel-national" inputmode="numeric" pattern="0[0-9]{9}" maxlength="10" placeholder="06 12 34 56 78" required></div>' +
            '<div class="field"><label for="rwz-email">Email *</label><input id="rwz-email" name="email" type="email" autocomplete="email" required></div>' +
          '</div>' +
          // Bloc adresse — affiché seulement si pickup = "remote".
          '<fieldset class="rep-shipping" data-shipping-block hidden>' +
            '<legend>Adresse pour l’étiquette d’envoi</legend>' +
            '<div class="field"><label for="rwz-street">Adresse *</label><input id="rwz-street" name="street" type="text" autocomplete="street-address" placeholder="12 rue de la Paix" data-shipping-required></div>' +
            '<div class="field-row">' +
              '<div class="field"><label for="rwz-zip">Code postal *</label><input id="rwz-zip" name="postal_code" type="text" autocomplete="postal-code" inputmode="numeric" pattern="[0-9]{5}" maxlength="5" placeholder="91070" data-shipping-required></div>' +
              '<div class="field"><label for="rwz-city">Ville *</label><input id="rwz-city" name="city" type="text" autocomplete="address-level2" placeholder="Bondoufle" data-shipping-required></div>' +
            '</div>' +
            '<div class="field"><label for="rwz-country">Pays *</label><input id="rwz-country" name="country" type="text" autocomplete="country-name" value="France" data-shipping-required></div>' +
          '</fieldset>' +
          '<div class="hp" aria-hidden="true"><label>Ne pas remplir<input type="text" name="website" tabindex="-1" autocomplete="off"></label></div>' +
          '<div class="rep-result__actions">' +
            '<button type="submit" class="btn btn--accent btn--lg" data-rep-submit>Recevoir ma proposition</button>' +
            '<a href="' + shopUrl + '" class="btn btn--ghost btn--lg">Voir la boutique</a>' +
          '</div>' +
          '<p class="booking__status" data-status role="status" aria-live="polite"></p>' +
        '</form>' +
        '<div class="rep-step__nav"><button type="button" class="link-back" data-back>← Retour</button> · <button type="button" class="link-back" data-restart>Recommencer</button></div>';
      return w;
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    $$('[data-reprise-wizard]').forEach(init);
  });
})();
